import axios from 'axios';
import {
    DOCUMENT_TEMPLATE_LIST_REQUEST, DOCUMENT_TEMPLATE_LIST_SUCCESS, DOCUMENT_TEMPLATE_LIST_FAIL,
    DOCUMENT_TEMPLATE_LIST_BY_IDS_REQUEST, DOCUMENT_TEMPLATE_LIST_BY_IDS_SUCCESS, DOCUMENT_TEMPLATE_LIST_BY_IDS_FAIL,
    DOCUMENT_TEMPLATE_DETAILS_REQUEST, DOCUMENT_TEMPLATE_DETAILS_SUCCESS, DOCUMENT_TEMPLATE_DETAILS_FAIL,
    DOCUMENT_TEMPLATE_CREATE_REQUEST, DOCUMENT_TEMPLATE_CREATE_SUCCESS, DOCUMENT_TEMPLATE_CREATE_FAIL,
    DOCUMENT_TEMPLATE_UPDATE_REQUEST, DOCUMENT_TEMPLATE_UPDATE_SUCCESS, DOCUMENT_TEMPLATE_UPDATE_FAIL,
    DOCUMENT_TEMPLATE_DELETE_REQUEST, DOCUMENT_TEMPLATE_DELETE_SUCCESS, DOCUMENT_TEMPLATE_DELETE_FAIL,
    DOCUMENT_TEMPLATE_DTO_REQUEST, DOCUMENT_TEMPLATE_DTO_SUCCESS, DOCUMENT_TEMPLATE_DTO_FAIL,
    DOCUMENT_TEMPLATE_PUBLIC_LIST_REQUEST, DOCUMENT_TEMPLATE_PUBLIC_LIST_SUCCESS, DOCUMENT_TEMPLATE_PUBLIC_LIST_FAIL,
} from '../constants/documentTemplateConstants';

// Helper functions
const getAuthConfig = (token) => ({
    headers: {
        'Content-type': 'application/json',
        'Authorization': `Bearer ${token}`
    }
});

const formatErrorMessage = (error) => {
    const errorMessages = [];
    if (error.response?.data) {
        if (error.response.data.errors) {
            Object.entries(error.response.data.errors).forEach(([key, value]) => {
                errorMessages.push(`${key}: ${value[0]}`);
            });
        }
        if (error.response.data.detail) {
            errorMessages.push(`Detail: ${error.response.data.detail}`);
        }
        if (error.response.data.message) {
            errorMessages.push(`Message: ${error.response.data.message}`);
        }
    }
    return errorMessages.length > 0 ? errorMessages : [error.message || "An error occurred, please try again later"];
};

const API_BASE_URL = '/dotnet_api/v1/documentTemplate';

export const listDocumentTemplates = (params = {}) => async (dispatch, getState) => {
    try {
        dispatch({ type: DOCUMENT_TEMPLATE_LIST_REQUEST });
        const config = {
            ...getAuthConfig(getState().userLogin.userInfo.token),
            params
        };
        const { data } = await axios.get(`${API_BASE_URL}/all`, config);
        dispatch({ type: DOCUMENT_TEMPLATE_LIST_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: DOCUMENT_TEMPLATE_LIST_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const listDocumentTemplatesByIds = (ids) => async (dispatch, getState) => {
    try {
        dispatch({ type: DOCUMENT_TEMPLATE_LIST_BY_IDS_REQUEST });
        const { data } = await axios.post(
            `${API_BASE_URL}/ids/all`,
             ids ,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: DOCUMENT_TEMPLATE_LIST_BY_IDS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: DOCUMENT_TEMPLATE_LIST_BY_IDS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const getDocumentTemplateDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: DOCUMENT_TEMPLATE_DETAILS_REQUEST });
        const { data } = await axios.get(
            `${API_BASE_URL}/${id}`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: DOCUMENT_TEMPLATE_DETAILS_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: DOCUMENT_TEMPLATE_DETAILS_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const createDocumentTemplate = (documentTemplateData) => async (dispatch, getState) => {
    try {
        dispatch({ type: DOCUMENT_TEMPLATE_CREATE_REQUEST });
        const { data } = await axios.post(
            API_BASE_URL,
            documentTemplateData,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: DOCUMENT_TEMPLATE_CREATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: DOCUMENT_TEMPLATE_CREATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const updateDocumentTemplate = (id, changes) => async (dispatch, getState) => {
    try {
        dispatch({ type: DOCUMENT_TEMPLATE_UPDATE_REQUEST });
        const { data } = await axios.patch(
            `${API_BASE_URL}/${id}`,
            changes,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: DOCUMENT_TEMPLATE_UPDATE_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: DOCUMENT_TEMPLATE_UPDATE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const deleteDocumentTemplate = (id) => async (dispatch, getState) => {
    try {
        dispatch({ type: DOCUMENT_TEMPLATE_DELETE_REQUEST });
        await axios.delete(
            `${API_BASE_URL}/${id}`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: DOCUMENT_TEMPLATE_DELETE_SUCCESS });
    } catch (error) {
        dispatch({
            type: DOCUMENT_TEMPLATE_DELETE_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const loadDocumentTemplateDto = () => async (dispatch, getState) => {
    try {
        dispatch({ type: DOCUMENT_TEMPLATE_DTO_REQUEST });
        const { data } = await axios.get(
            `${API_BASE_URL}/dto`,
            getAuthConfig(getState().userLogin.userInfo.token)
        );
        dispatch({ type: DOCUMENT_TEMPLATE_DTO_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: DOCUMENT_TEMPLATE_DTO_FAIL,
            payload: formatErrorMessage(error)
        });
    }
};

export const listPublicDocumentTemplates = (params = {}) => async (dispatch) => {
    try {
        dispatch({ type: DOCUMENT_TEMPLATE_PUBLIC_LIST_REQUEST });
        const { data } = await axios.get(`/dotnet_api/v1/documentTemplate/public`, { params });
        dispatch({ type: DOCUMENT_TEMPLATE_PUBLIC_LIST_SUCCESS, payload: data });
    } catch (error) {
        dispatch({
            type: DOCUMENT_TEMPLATE_PUBLIC_LIST_FAIL,
            payload: formatErrorMessage(error)
        });
    }
}; 